import { render } from "./ReceiptSubstractionSet.vue?vue&type=template&id=5db6240f"
import script from "./ReceiptSubstractionSet.vue?vue&type=script&lang=js"
export * from "./ReceiptSubstractionSet.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/hostess.westfield.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__